@if (starRating != null) {
  <div>
    @for (rating of ratings; track rating) {
      <span class="me-1">
        @if (rating <= starRating && !showHalfStar(starRating, rating)) {
          <img
            alt="{{ 'productReview.filled' | cxTranslate }} {{ 'productReview.star' | cxTranslate }}"
            class="review-star"
            src="/images/product/review/star-filled-review.svg" />
        }
        @if (showHalfStar(starRating, rating)) {
          <img
            alt="{{ 'productReview.half' | cxTranslate }} {{ 'productReview.star' | cxTranslate }}"
            class="review-star"
            src="/images/product/review/star-half-review.svg" />
        }
        @if (rating > starRating && !showHalfStar(starRating, rating)) {
          <img
            alt="{{ 'productReview.empty' | cxTranslate }} {{ 'productReview.star' | cxTranslate }}"
            class="review-star"
            src="/images/product/review/star-empty-review.svg" />
        }
      </span>
    }
  </div>
}
